import { render, staticRenderFns } from "./VaIconRich.vue?vue&type=template&id=46c8d0d9&"
import script from "./VaIconRich.vue?vue&type=script&lang=js&"
export * from "./VaIconRich.vue?vue&type=script&lang=js&"
import style0 from "./VaIconRich.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports